(function(){
  var toastRoot = null;
  var hideTimer = null;

  /* Wo ein Cart-Drawer existiert, uebernimmt der das Feedback – dann kein Toast. */
  function drawerHandlesIt(){
    return !!document.getElementById('cart-drawer');
  }

  function ensureRoot(){
    if (toastRoot) return toastRoot;
    toastRoot = document.createElement('div');
    toastRoot.className = 'srv-mc';
    toastRoot.setAttribute('aria-live', 'polite');
    document.body.appendChild(toastRoot);
    return toastRoot;
  }

  function escapeHtml(s){
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents, symbol){
    var n = (Number(cents) || 0) / 100;
    return n.toFixed(2).replace('.', ',') + ' ' + (symbol || '€');
  }

  function resizeImg(url, size){
    if (!url) return url;
    return url.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, '_' + size + 'x' + size + '_crop_center$1$2');
  }

  function hide(){
    if (!toastRoot) return;
    toastRoot.classList.remove('is-open');
  }

  function render(item, cart){
    var root = ensureRoot();
    var symbol = (window.SRV_CART && window.SRV_CART.symbol) || '€';
    var price = item.final_line_price != null ? item.final_line_price : (item.line_price != null ? item.line_price : item.final_price);
    var img = item.image ? resizeImg(item.image, 120) : '';

    root.innerHTML =
      '<div class="srv-mc__card" role="status">' +
        '<button class="srv-mc__close" type="button" aria-label="Schließen">&times;</button>' +
        '<div class="srv-mc__row">' +
          (img ? '<img class="srv-mc__img" src="' + img + '" alt="">' : '<div class="srv-mc__img srv-mc__img--empty"></div>') +
          '<div class="srv-mc__info">' +
            '<p class="srv-mc__added">Zum Warenkorb hinzugefügt</p>' +
            '<p class="srv-mc__title">' + escapeHtml(item.product_title || item.title) + '</p>' +
            (item.variant_title ? '<p class="srv-mc__variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
          '</div>' +
          '<div class="srv-mc__price">' + money(price, symbol) + '</div>' +
        '</div>' +
        '<div class="srv-mc__footer">' +
          '<span class="srv-mc__count">' + cart.item_count + ' Artikel · ' + money(cart.total_price, symbol) + '</span>' +
          '<a class="srv-mc__cta" href="/cart">Warenkorb ansehen</a>' +
        '</div>' +
      '</div>';

    var closeBtn = root.querySelector('.srv-mc__close');
    if (closeBtn) closeBtn.addEventListener('click', hide);

    requestAnimationFrame(function(){ root.classList.add('is-open'); });

    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, 6000);
  }

  var origFetch = window.fetch;
  window.fetch = function(){
    var args = arguments;
    var url = (args[0] && args[0].url) || args[0] || '';
    var p = origFetch.apply(this, args);

    if (typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url) && !drawerHandlesIt()) {
      p.then(function(res){
        if (!res || !res.ok) return;
        var clone;
        try { clone = res.clone(); } catch (e) { return; }
        clone.json().then(function(data){
          var item = (data && data.items && data.items.length) ? data.items[data.items.length - 1] : data;
          if (!item || (!item.id && !item.variant_id)) return;
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function(r){ return r.json(); })
            .then(function(cart){ render(item, cart); });
        }).catch(function(){});
      });
    }

    return p;
  };
})();
